import { Box, Grid } from "@mui/material"
import MenuTab from "../../../component/tabs/MenuTab"
import TerreniForm from "../../structure/Terreni/TerreniForm"
import StabilimentiForm from "../../structure/Stabilimenti/StabilimentiForm"
import { useSelector } from "react-redux"

const SubStabilimentiLogistica = ({ Component }) => {
    const singleData = useSelector((state) => state?.stabilimenti?.singleStabilimento);
    console.log("singo", singleData);
    return (
        <>
            <div className="pageTemplate">

                <Grid container spacing={3}>
                    <Grid  size={{lg:3, md:4, xs:12}}>
                        {/* <StabilimentoForm /> */}
                        {window.location.href.includes("/strutture/stabiliment/Giacenze") ? <TerreniForm /> : < StabilimentiForm singleData={singleData} />}

                    </Grid>
                    <Grid  size={{lg:9, md:8, xs:12}}>
                        <Box className="TemplateForm__right">
                            <MenuTab subStabilimentiLogistica={true} />
                        </Box>
                        {Component && <Component />}
                    </Grid>
                </Grid>
            </div>
        </>
    )
}

export default SubStabilimentiLogistica
